// noinspection JSDeprecatedSymbols

(function ($) {

		let initFacets = function () {

			let isTabletOrAbove = window.matchMedia('(min-width: 47.5rem)').matches;

			if (!isTabletOrAbove) {
				$('#filters').removeAttr('open');
			}

			$(document).on('facetwp-loaded', function () {
				$('.facetwp-facet').each(function () {
					let $facet = $(this);
					let facet_name = $facet.attr('data-name');
					let facet_label = FWP.settings.labels[facet_name];

					let excludedFacets = [
						'result_count',
						'pagination',
						'reset'
					]

					if (!excludedFacets.includes(facet_name)) {
						if (!($facet).is(':empty')) {
							if ($facet.closest('.facet-wrap').length < 1 && $facet.closest('.facetwp-flyout').length < 1) {
								$facet.wrap('<div class="facet-wrap"></div>');
								$facet.parent('.facet-wrap').prepend('<div class="facet-label">' + facet_label + '</div>');
							}
						}

						if (($facet).hasClass('is-hidden')) {
							$facet.prev('.facet-label').hide();

							if (FWP.facets[facet_name].length) {
								FWP.reset(facet_name);
							}
						} else {
							$facet.prev('.facet-label').show();
						}
					}
				});

				let facetCounts = $('.listing-header');

				if (facetCounts.length) {
					let topOfFilteredResults = (facetCounts.offset().top - window.innerHeight / 10);
					let scrollPos = window.pageYOffset;

					if (scrollPos > 1) {
						if (topOfFilteredResults > scrollPos + window.innerHeight / 1.5 || topOfFilteredResults < scrollPos - window.innerHeight / 10) {
							$('html, body').stop().animate({
								scrollTop: topOfFilteredResults
							}, 250);
						}
					}
				}
			});

			$(document).on('submit', '.filters__form', function (e) {
				/* we've disabled auto-refresh on submit, so we need to tie this to FWP */
				/* bound to submit of form rather than click of button so that the enter key works as expected */
				e.preventDefault();
				FWP.refresh();
			});

			$(document).on('click', '.facetwp-checkbox', function (e) {
				/* FacetWP doesn't currently seem to update aria-checked until facetwp-refresh
					which is too late, now we've disabled auto-refresh, so let's do it ourselves */
				let currentlyChecked = $(this).hasClass('checked');

				if (currentlyChecked) {
					// if currentlyChecked, it's in the process of being checked, so set to true
					$(this).attr('aria-checked', true);
				} else {
					// if not currentlyChecked, it's in the process of being unchecked, so set to false
					$(this).attr('aria-checked', false);
				}
			});
		}

		// --

		$(document).ready(function () {
			initFacets();
		});

	}
)
(jQuery);
